import React, { useEffect, useState } from 'react'
import { ICompanyPanel } from '../../CargarPorFormulario/InterfaceFormulario'
import HeaderReusable, { IHeaderActionButton } from '../HeaderEmpresa'
import { useNavigate, useParams } from 'react-router-dom';
import UpdateEmpresa from './UpdateEmpresa';
import { Stack } from 'office-ui-fabric-react';
import { Text } from '@fluentui/react';
import { v4 as uuidv4 } from 'uuid';
import { FieldValues, useForm } from 'react-hook-form';
import { ButtonProps, CustomModalEmp } from '../CustomModalEmp';
import { DateCustom } from '../../../lib/DateCustom';
import { t } from 'i18next';
import { IdetailCompany } from '../../../system/company/Company';
import Loading from '../../Spinners/Loading';

function DetailsEmpresa(props:ICompanyPanel) {
     const uuid = uuidv4();
     const navigate = useNavigate();
     const [edit, setEdit] = useState<boolean>(false);
     const [modal,setModal] = useState<boolean>(false)
     const {handleSubmit,register,setValue,watch,formState:{errors},clearErrors,trigger} = useForm();
     const [errorSoap, setErrorSoap] = useState<number>(0);
     const [detailcompany, setDetailcompany] = useState<IdetailCompany>();
     let {empresaId} = useParams();

     const getDetailCompany =async()=>{
      const data = await props.system.getCompanySystem().detailCompany(uuid,'get-detail-company',empresaId);
      setDetailcompany(data);
     }

    const buttonaction:IHeaderActionButton[]  = [
        {
        iconName: 'Back',
        label: t('Volver'),
        onClick: () => navigate("/empresas"),
        className: "Button_back",
        colorIcon:"#0078d4"
        },
        edit? {
        iconName: 'Edit',
        label: t('Cancelar'),
        onClick: () => setEdit(!edit), 
        className: "Button_back",
        colorIcon:"#0078d4"
        }:{
          iconName: 'Edit',
          label: t('Modificar'),
          onClick: () => setEdit(!edit), 
          className: "Button_back",
          colorIcon:"#0078d4",
          disabled:detailcompany?false:true
        },
        {
        iconName: 'Save',
        label: t('Guardar'),
        onClick: () => HamdlerErrorSubmit(), 
        className: "Button_view",disabled:!edit
        },
    ]
    const buttonsOtion:ButtonProps[] = [{ text: t("SI"), onClick: ()=>modalButtons(),primary:true },{text:t('NO'),onClick:()=>setModal(false)}];

    const styleDetail = {root: { fontWeight: "bold", color: "rgba(96, 94, 92, 0.49)" }};
    const styleRuc = { root: { fontWeight: "bold", color: "#605E5C" } };
    const stylebodyDetail = { childrenGap: 5,padding:'6.4px 6.4px 6.4px 25px' };

    const validateDate = ():boolean=>{
      const dateString = watch('fechaingreso');
      const dateToday = DateCustom.FormatDatetoAMDStr(new Date());
      return dateString < dateToday;
    }

    const HamdlerErrorSubmit = async ()=>{
      const data =  await trigger();
        if((errorSoap === 0) && data){
          setModal(true);
        } 
    };

    const modalButtons =async ()=>{
      setModal(false)
      await HandlerSubmit()
      setEdit(false);
    }
      
    const HandlerSubmit = handleSubmit(async(data: FieldValues)=>{
      if(data){
        props.changeBlockUI(true);
          const result = await props.system.getCompanySystem().updateCompany({...data,id:empresaId},uuid,'update-company');
        if(result?.status === 'success'){
          await getDetailCompany();
          props.changeBlockUI(false);
          props.courier.messageSuccess(t('La empresa se ha modificado correctamente.'));
          // Remover el ls para que se actualize el contexto cuando se crea o edita un proyecto 
          localStorage.removeItem("/proyectoDVM/getFormContext")
        }else{
          props.courier.messageError(t('La empresa no se ha podido modificadar.'));
          }
        }
        props.changeBlockUI(false);
    });

    useEffect(()=>{
      getDetailCompany();
      register("fechabaja",{required:true});
      register("fechaingreso",{required:true});
      register("tipemp",{required:true});
      register("pais",{required:true});
      register("nif",{required:true});
      register("facturable",{value:true});
      register("ciudad",{required:true});
      register("distrito",{required:true});
      register("direccion",{required:true});
      register("name",{required:true});
      register('activo',{value:true})
      register("emp_responsable_colid", { required: false });
    },[]);

    if(detailcompany === undefined){
      return <Loading title='Cargando' description='Por favor espere estamos procesando la información necesaria para completar su solicitud.'/>
    }

  return (
    <>
      <form style={{ backgroundColor:'#faf9f8'}}>
            <HeaderReusable
              title={t("Empresas")}
              icontitle='CityNext'
              actions={buttonaction}
              />
              {detailcompany && 
              <Stack className='header_emp_create'>
                <Text style={{color:'rgb(50, 49, 48)',fontSize:'15px',fontWeight:'bold'}} >{detailcompany?.emp_nombre || ""}</Text>
                <Stack verticalAlign='end' tokens={stylebodyDetail}>
                  <Text variant="medium" styles={styleRuc}> {detailcompany?.emp_nro_admin_tributaria || ""} </Text>
                  <Text variant="medium" styles={styleDetail}>{detailcompany?.emp_tipo || ""}</Text>
                  <Text variant="smallPlus" styles={styleDetail}> 
                    {detailcompany?.emp_depto ||"" }, {detailcompany?.emp_distrito || ""}
                    </Text>
                </Stack>
              </Stack> }
            { (edit && detailcompany) &&
            <UpdateEmpresa
              changeBlockUI={props.changeBlockUI}
              courier={props.courier}
              system={props.system}
              user={props.user}
              uuid={uuid}
              setModificar={setEdit}
              form={{clearErrors,errors,handleSubmit,register,setValue,watch}}
              setModal={setModal}
              errorSoap={errorSoap}
              setErrorSoap={setErrorSoap}
              getDetailCompany={detailcompany}
            />
            }
            <CustomModalEmp isOpen={modal} iconName='Warning'
              message={t("La información de la empresa a modificar no actualiza / modifica proyectos ni actividades generadas.")}
              question={t("¿Deseas continuar con la modificación de la empresa?")}
              buttons={buttonsOtion}
              message2={validateDate()?t("La fecha de registro es menor a la fecha actual."):undefined}
            />
      </form>
    </>
  )
}

export default DetailsEmpresa